import {
  resolveApiErrorCode,
  resolveApiErrorMessage,
  resolveApiValidationMessages,
} from '../../../lib/apiError';

/*
 * Отказы записи теста. Конфликт (409) и пропавший тест (404) значат, что строка на
 * экране устарела: её закрыли или вернули в другом окне, изменила синхронизация с
 * 1С или тест сняли. Мутация перезапрашивает список, а здесь - текст для человека.
 */

const STALE_MESSAGES: Readonly<Record<string, string>> = {
  sample_test_not_testing:
    'Тест уже закрыт - похоже, итог поставили в другом окне. Список обновлён.',
  sample_test_not_closed:
    'Тест уже в тестировании - похоже, его вернули в другом окне. Список обновлён.',
  sample_test_changed:
    'Тест только что изменили - коллега или синхронизация с 1С. Список обновлён, повторите действие.',
  sample_test_not_found:
    'Теста больше нет: отгрузку образцов отозвали в 1С. Список обновлён.',
};

const resolveStaleMessage = (error: unknown): string | undefined => {
  const code = resolveApiErrorCode(error);

  return code !== undefined && Object.hasOwn(STALE_MESSAGES, code)
    ? STALE_MESSAGES[code]
    : undefined;
};

/** Отказ из-за устаревшей строки: после него список перезапрашивается. */
export const isStaleSampleTestError = (error: unknown): boolean =>
  resolveStaleMessage(error) !== undefined;

/** Текст отказа: устаревшая строка, поля формы (400) или сообщение сервера. */
export const resolveSampleTestErrorMessage = (error: unknown): string => {
  const stale = resolveStaleMessage(error);
  if (stale !== undefined) return stale;

  const fields = resolveApiValidationMessages(error);
  if (fields.length > 0) return fields.join(' ');

  return resolveApiErrorMessage(error);
};
